import React from 'react';
import c from 'classnames';
import { ThumbStatusTypes } from '../types';
import SimpleTooltip from '../../tooltips/dsPreset/SimpleTooltip';
import ThumbStatusIndicator from '../ThumbStatusIndicator/ThumbStatusIndicator';
import s from './ThumbStatusIndicators.scss';

interface Props {
  className?: string;
  indicators: {
    type: ThumbStatusTypes;
    tooltip?: string;
    hasAccess?: boolean;
  }[];
}

const ThumbStatusIndicators: React.FC<Props> = ({ className, indicators }) => {
  return (
    <div className={c(s['root'], className)}>
      {indicators.map(({ type, tooltip, hasAccess }) => (
        <SimpleTooltip key={type} text={tooltip} usePortal>
          <ThumbStatusIndicator
            key={type}
            type={type}
            hasAccess={hasAccess}
            size="medium"
          />
        </SimpleTooltip>
      ))}
    </div>
  );
};
ThumbStatusIndicators.displayName = 'ThumbStatusIndicators';

export default ThumbStatusIndicators;
